const featuredProducts = [
  {
    id: 1,
    name: 'Nike Dunk Low Retro',
    nameDe: 'Nike Dunk Low Retro',
    price: '89,99 €',
    image: 'https://readdy.ai/api/search-image?query=white%20and%20light%20grey%20Nike%20Dunk%20Low%20sneakers%20displayed%20on%20clean%20warm%20beige%20surface%2C%20simple%20minimalist%20product%20photography%2C%20soft%20natural%20daylight%2C%20clean%20shadows%2C%20premium%20ecommerce%20aesthetic%2C%20centered%20composition%20with%20generous%20negative%20space%2C%20warm%20cream%20tones&width=600&height=600&seq=product-scroll-01-new&orientation=squarish',
    tag: 'Top',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
  },
  {
    id: 2,
    name: 'Essential Hoodie Cream',
    nameDe: 'Essential Hoodie Cream',
    price: '45,50 €',
    image: 'https://readdy.ai/api/search-image?query=cream%20beige%20oversized%20pullover%20hoodie%20laid%20flat%20on%20light%20warm%20surface%2C%20simple%20fashion%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20Scandinavian%20aesthetic%2C%20warm%20neutral%20tones%2C%20minimal%20composition&width=600&height=600&seq=product-scroll-02-new&orientation=squarish',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
  },
  {
    id: 3,
    name: 'Carhartt Cargo Pants',
    nameDe: 'Carhartt Cargo Pants',
    price: '62,00 €',
    image: 'https://readdy.ai/api/search-image?query=olive%20green%20cargo%20workwear%20pants%20neatly%20folded%20on%20light%20beige%20wooden%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20daylight%2C%20clean%20composition%2C%20warm%20earthy%20tones%2C%20premium%20ecommerce%20photography&width=600&height=600&seq=product-scroll-03-new&orientation=squarish',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
  },
  {
    id: 4,
    name: 'New Era 59Fifty Cap',
    nameDe: 'New Era 59Fifty Cap',
    price: '34,99 €',
    image: 'https://readdy.ai/api/search-image?query=black%20new%20era%20baseball%20cap%20with%20curved%20brim%20on%20clean%20warm%20beige%20surface%2C%20minimalist%20product%20photography%2C%20soft%20studio%20lighting%2C%20simple%20clean%20composition%2C%20neutral%20warm%20background%2C%20premium%20ecommerce%20aesthetic&width=600&height=600&seq=product-scroll-04-new&orientation=squarish',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
  },
];

export default function ProductScroll() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-12 lg:px-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Trendprodukte
          </h2>
          <p className="text-foreground-600 text-sm max-w-lg mx-auto">
            Die beliebtesten Artikel aus unseren OOPBUY Spreadsheet Listen
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuredProducts.map((product) => (
            <a
              key={product.id}
              href={product.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col cursor-pointer"
            >
              <div className="relative bg-background-50 rounded-lg overflow-hidden mb-3">
                {product.tag && (
                  <span className="absolute top-3 left-3 z-10 px-2.5 py-1 bg-foreground-900 text-white text-[11px] font-semibold rounded whitespace-nowrap">
                    {product.tag}
                  </span>
                )}
                <div className="aspect-square overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.nameDe}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 text-center whitespace-nowrap">
                {product.nameDe}
              </h3>
              <p className="text-sm text-foreground-600 text-center mt-1">
                {product.price}
              </p>
            </a>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-white text-sm font-semibold rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Alle Produkte ansehen
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}